import { TooltipHorizontalOffset, TooltipVerticalOffset } from '../types.js';
import { TOOLTIP_POSITION_DEFAULT_RETURN } from '../constants.js';
import { eventPointNative } from './eventPoint.js';
import { sortBarChartData } from '../../VerticalBarChart/utilities/sortBarChartData.js';

function getVerticalBarChartTooltipPosition({
  chartBounds,
  containerBounds,
  data,
  event,
  eventType,
  index,
  longestSeriesIndex,
  type,
  xScale,
  yScale
}) {
  const isStacked = type === 'stacked';
  if (eventType === 'mouse' && (event instanceof MouseEvent || event instanceof TouchEvent)) {
    const point = eventPointNative(event);
    if (point == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const {
      svgX
    } = point;
    const currentPoint = svgX - chartBounds.x;
    const activeIndex = Math.floor(currentPoint / xScale.step());
    if (activeIndex < 0 || activeIndex > data[longestSeriesIndex].data.length - 1) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    return formatPositionForTooltip({
      chartBounds,
      containerBounds,
      index: activeIndex,
      xScale,
      yScale,
      data,
      isStacked
    });
  } else if (index != null) {
    return formatPositionForTooltip({
      chartBounds,
      containerBounds,
      index,
      xScale,
      yScale,
      data,
      isStacked
    });
  }
  return TOOLTIP_POSITION_DEFAULT_RETURN;
}
function formatPositionForTooltip({
  chartBounds,
  containerBounds,
  data,
  index,
  xScale,
  yScale,
  isStacked
}) {
  var _xScale;
  if (index == null) {
    return TOOLTIP_POSITION_DEFAULT_RETURN;
  }
  const xPosition = (_xScale = xScale(`${index}`)) !== null && _xScale !== void 0 ? _xScale : 0;
  const highestValue = getHighestValue(data, index);
  const x = containerBounds.x + xPosition;
  const y = yScale(highestValue < 0 ? 0 : highestValue) + containerBounds.y;
  return {
    x: chartBounds.x + x,
    y: Math.abs(y),
    position: {
      horizontal: TooltipHorizontalOffset.Center,
      vertical: TooltipVerticalOffset.Above
    },
    activeIndex: index
  };
  function getHighestValue(data, index) {
    if (isStacked) {
      var _sortedData$index$red;
      const sortedData = sortBarChartData(data);
      return (_sortedData$index$red = sortedData[index].reduce(sumPositiveData, 0)) !== null && _sortedData$index$red !== void 0 ? _sortedData$index$red : 0;
    }
    const values = data.map(series => series.data[index].value).filter(Boolean);
    return Math.max(...values);
  }
}
function sumPositiveData(prevValue, currValue) {
  return currValue < 0 ? prevValue : prevValue + currValue;
}

export { getVerticalBarChartTooltipPosition };
